import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import { API } from 'aws-amplify';
import { Query } from 'react-apollo';
import moment from "moment";
import { useSelector } from 'react-redux';
import Spin from 'components/common/Spin';
import { GET_ACCOUNT_BY_SUB } from 'graphql/calendar';
import Settings from 'components/pages/calendar/Settings';

const DURATION = {
  lcs: 45,
  hcs: 30,
  fas: 30,
};

class CronofyEl extends React.Component {
  componentDidMount() {
    const scheduler = window.CronofyElements.AvailabilityRules({
      target_id: 'cronofy-element',
      element_token: this.props.token,
      availability_rule_id: 'weadmit_hours',
      tzid: this.props.timezone,
      config: {
        week_start_day: 'monday',
        start_time: '07:00',
        end_time: '23:00',
        duration: this.props.duration,
      },
      styles: {
        colors: {
          // available: "#84de8a",
          // unavailable: "#f57d7d",
          primary: '#1278FB',
        },
        prefix: 'custom-name',
      },
      callback: (e) => {
        console.log(e);
      },
    });

    this.scheduler = scheduler;
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.timezone !== this.props.timezone) {
      console.log('updating timezone to- ', nextProps.timezone);
      this.scheduler.update({ tzid: nextProps.timezone });
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timezone !== this.props.timezone) {
      console.log('updating timezone to- ', this.props.timezone);
      this.scheduler.update({ tzid: this.props.timezone });
    }
  }

  render() {
    return <div id="cronofy-element" />;
  }
}

const CalendarView = ({ match }) => {
  const [token, setToken] = useState();
  const user = useSelector((state) => state.user.user);
  useEffect(() => {
    API.post('api', '/admin/calendar/element_token', { body: { userId: match.params.id }})
      .then(
        (resp) => {
          setToken(resp);
        },
        (e) => {
          alert(e.response.data.message);
        }
      )
  }, []);

  const duration = DURATION[match.params.role];

  return (
    <Box>
      <Spin spinning={!token}>
        <Box>
          {token && (
            <Query query={GET_ACCOUNT_BY_SUB} variables={{ sub: token.sub }}>
              {({ data, loading}) => {
                if (loading) return <Spin spinning />
                return (
                  <div>
                  <CronofyEl
                    {...token}
                    timezone={user.timezone}
                    duration={duration}
                    account={data.accounts[0]}
                  />
                  <Settings account={data.accounts[0]} />
                  </div>
                )
              }}
            </Query>
          )}
        </Box>
      </Spin>
    </Box>
  )
}

export default CalendarView;
